/* eslint-disable max-lines-per-function */
import React from "react";
import { IconButton, InputAdornment, styled, TextField, Tooltip } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ResetSearchIcon from "@mui/icons-material/Clear";
import { useSidebarFilters } from "../sidebar-filters";

const CustomTextField = styled(TextField)(() => ({
  "& .MuiInputBase-input": {
    fontWeight: "400 !important", // This is to override bootstrap nonsense
  },
  "& .MuiInputLabel-root": {
    fontWeight: "400 !important", // This is to override bootstrap nonsense
  },
}));

const SearchBox: React.FC = () => {
  const { setTextFilter, textFilter } = useSidebarFilters();
  const [value, setValue] = React.useState(textFilter);
  const setFilter = (filter:string) => {
    setValue(filter);
    setTextFilter(filter.trim());
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilter(e.target.value);
  };
  return (
    <CustomTextField
      onChange={handleChange}
      placeholder="Search"
      autoComplete="off"
      value={value}
      fullWidth
      size="small"
      slotProps={{
        htmlInput: {
          "aria-label": "Clear Search",
          "data-cy": "search-box",
        },
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <Tooltip title="Search">
                <SearchIcon fontSize="small" />
              </Tooltip>
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                disabled={!value}
                onClick={() => setFilter("")}
                aria-label="Clear Search"
              >
                <ResetSearchIcon
                  fontSize="small"
                  aria-label="clear"
                />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};


export default SearchBox;
